exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subscribe-icon{font-weight:600;cursor:pointer}.subscribebutton{border-radius:5px;padding:5px;color:#fff;cursor:pointer}.subred{background-color:red}.subgreen{background-color:#3db000;width:98px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-eaf881d8","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/BookmarkedChannel.vue
// module id = A0wf
// module chunks = 0